
import React, { useState, useEffect } from 'react';
import { Dropdown, Checkbox, TextInput, Button } from 'carbon-components-react';
import i18n from "../../i18n";
import { MultiSelect } from 'carbon-components-react';
import {
    withKnobs,
    boolean,
    select,
    text,
    object,
} from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';
import "global.scss";
require("./_add-task.scss");


const defaultLabel = 'MultiSelect Label';
const defaultPlaceholder = i18n.t('manageschedule.Automata');

const types = {
    'Default (default)': 'default',
    'Inline (inline)': 'inline',
};
const props = () => ({
    id: text('Automata (id)', 'Automata IDDD'),
    titleText: text('Title (titleText)', i18n.t('manageschedule.Automata')),
    helperText: text('Helper text (helperText)', ''),
    disabled: boolean('Disabled (disabled)', false),
    light: boolean('Light variant (light)', false),
    useTitleInItem: boolean('Show tooltip on hover', false),
    type: select('UI type (Only for `<MultiSelect>`) (type)', types, 'default'),
    size: select('Field size (size)', sizes, undefined) || undefined,
    direction: select('Dropdown direction (direction)', directions, 'bottom'),
    label: text('Label (label)', defaultLabel),
    invalid: boolean('Show form validation UI (invalid)', false),
    invalidText: text(
        'Form validation UI content (invalidText)',
        'Invalid Selection'
    ),
    warn: boolean('Show warning state (warn)', false),
    warnText: text(
        'Warning state text (warnText)',
        'Selecting more items may increase processing time'
    ),
    onMenuChange: action('onMenuChange'),
    listBoxMenuIconTranslationIds: object(
        'Listbox menu icon translation IDs (for translateWithId callback)',
        {
            'close.menu': 'Close menu',
            'open.menu': 'Open menu',
            'clear.all': 'Clear all',
            'clear.selection': 'Clear selection',
        }
    ),
    selectionFeedback: select(
        'Selection feedback',
        ['top', 'fixed', 'top-after-reopen'],
        'top-after-reopen'
    ),
});


const sizes = {
    'Extra large size (xl)': 'xl',
    'Default size': undefined,
    'Small size (sm)': 'sm',
};

const directions = {
    'Bottom (default)': 'bottom',
    'Top ': 'top',
};


const {
    listBoxMenuIconTranslationIds,
    selectionFeedback,
    ...multiSelectProps
} = props();




const AddTask = (props) => {

    useEffect(() => {
        props.validateForm();                                                                        
      }, [props.activeStep])

    let user = JSON.parse(localStorage.getItem('user'));
    const [occurances, setOccurances] = useState(
        ['Weekly', 'Monthly', 'Yearly']
    );
    const [frequency, SetFrequency] = useState(
        ['1', '2', '3', '4', '5', '6', '7']
    );
    // const [numberOfTasks, setNumberOfTasks] = useState(1);
    const AddTask = i18n.t('manageschedule.AddTask');
    //const SaveTask = i18n.t('manageschedule.SaveTask');
    const taskName = i18n.t('manageschedule.taskName');
    const EgStart = i18n.t('manageschedule.EgStart');
    const Taskdescription = i18n.t('manageschedule.Taskdescription');
    const Egstartapp = i18n.t('manageschedule.Egstartapp');
    
    const taskcompletion = i18n.t('manageschedule.taskcompletion');
    const Select = i18n.t('manageschedule.Select');
    const taskexception = i18n.t('manageschedule.taskexception');
    const Postcompletion = i18n.t('manageschedule.Postcompletion');
    const Task = i18n.t('manageschedule.Task');
    const TaskNameCannotBeBlank = i18n.t('manageschedule.TaskNameCannotBeBlank');
    const TaskDescriptionCannotBeBlank = i18n.t('manageschedule.TaskDescriptionCannotBeBlank');
    const TaskCompletionCannotBeBlank = i18n.t('manageschedule.TaskCompletionCannotBeBlank');
    const TaskExceptionCannotBeBlank = i18n.t('manageschedule.TaskExceptionCannotBeBlank');
    const AutomataNameCannotBeBlank = i18n.t('manageschedule.AutomataNameCannotBeBlank');
    const FailFastOnAnyErrors = i18n.t('manageschedule.FailFastOnAnyErrors');
    const IsInitialTask = i18n.t('manageschedule.IsInitialTask');

    // function renderNewTask() {
    //     let count = numberOfTasks;
    //     count = count + 1;
    //     setNumberOfTasks(count)
    // }

    if (user !== null && user.access_token !== null) {
        return (
            <>
                {Array.apply(null, { length: props.numberOfTasks }).map((e, i) => (
                    <div className="add-task">
                        <div className="bx--grid">
                            <div className="bx--row">
                                <div className="bx--col bx--col-sm-4">
                                    <div className="task-id">
                                        {Task} {i + 1}
                                    </div>
                                </div>
                            </div>
                            <div className="bx--row">
                                <div className="bx--col bx--col-sm-4">
                                    <TextInput
                                        disabled={props.review}
                                        required
                                        invalid={props.tasksArray[i].taskName!=="" ? false : true}
                                        helperText=""
                                        invalidText={props.tasksArray[i].taskName==="" ? TaskNameCannotBeBlank: ''}
                                        id={"Task" + i}
                                        labelText={taskName}
                                        placeholder={EgStart}
                                        value={props.tasksArray[i].taskName}
                                        onChange={(e) => props.handleTaskName(e, i)}
                                        onMouseOut={(e) => props.handleTaskName(e, i)}
                                    />
                                </div>
                                <div className="bx--col bx--col-sm-4">
                                    <TextInput
                                        id={"TaskDescp" + i}
                                        disabled={props.review}
                                        required
                                        invalid={props.tasksArray[i].taskDescription!=="" ? false : true}
                                        helperText=""
                                        invalidText={props.tasksArray[i].taskDescription==="" ? TaskDescriptionCannotBeBlank: ''}
                                        labelText={Taskdescription}
                                        placeholder={Egstartapp}
                                        value={props.tasksArray[i].taskDescription}
                                        onChange={(e) => props.handleTaskDescription(e, i)}
                                        onMouseOut={(e) => props.handleTaskDescription(e, i)}
                                    />
                                </div>
                            </div>
                            <div className="bx--row">
                                <div className="bx--col bx--col-sm-4">
                                    <Dropdown
                                        disabled={props.review}
                                        required
                                        invalid={props.tasksArray[i].taskCompletion!=="" ? false : true}
                                        helperText=""
                                        invalidText={props.tasksArray[i].taskCompletion==="" ? TaskCompletionCannotBeBlank: ''}
                                        ariaLabel="TaskCompletion"
                                        id="taskCompletion"
                                        items={props.taskCompletion}
                                        titleText={taskcompletion}
                                        label={Select}
                                        onChange={({ selectedItem }) => props.handleChangeTaskCompletion(selectedItem, i)}
                                        // onMouseOver={({ selectedItem }) => props.createSelectItems(selectedItem, i + 1, 'taskCompletion')}
                                        onMouseOut={({ selectedItem }) => props.createSelectItems(selectedItem, i + 1, 'taskCompletion')}
                                        selectedItem={props.tasksArray[i].taskCompletion}
                                        itemToString={(item) => (item ? item.key : '')} >
                                    </Dropdown>
                                </div>
                                    <div className="bx--col bx--col-sm-4">
                                        <Dropdown
                                            required
                                            disabled={props.review}
                                            invalid={props.tasksArray[i].taskException!=="" ? false : true}
                                            helperText=""
                                            invalidText={props.tasksArray[i].taskException==="" ? TaskExceptionCannotBeBlank: ''}
                                            ariaLabel="TaskException"
                                            id="taskException"
                                            items={props.taskCompletion}
                                            titleText={taskexception}
                                            label={Select}
                                            itemToString={(item) => (item ? item.key : '')}
                                            onChange={({ selectedItem }) => props.handleChangeTaskException(selectedItem, i)}
                                            onMouseOver={({ selectedItem }) => props.createSelectItems(selectedItem, i + 1, 'taskException')}
                                            onMouseOut={({ selectedItem }) => props.createSelectItems(selectedItem, i + 1, 'taskException')}
                                            selectedItem={props.tasksArray[i].taskException}
                                        />
                                    </div>
                                <div className="bx--col bx--col-sm-4">
                                    <TextInput
                                        disabled={props.review}
                                        required
                                        id="postCompletionDelay"
                                        invalid={props.tasksArray[i].valid_postCompletionDelay}
                                        helperText=""
                                        invalidText={props.tasksArray[i].helptext_postCompletionDelay}
                                        labelText={Postcompletion}
                                        placeholder="Eg: 20"
                                        value={props.tasksArray[i].postCompletionDelay}
                                        onChange={(e) => props.handleDelay(e, i)}
                                        
                                    />
                                </div>
                                <div className="bx--col bx--col-sm-4">
                                    <MultiSelect.Filterable
                                        disabled={props.review}
                                        required
                                        invalid={props.tasksArray[i].valid_automataName!=="" ? false : true}
                                        helperText=""
                                        invalidText={props.tasksArray[i].valid_automataName==="" ? AutomataNameCannotBeBlank: ''}
                                        {...multiSelectProps}
                                        items={props.RowsAutomata}
                                        itemToString={(item) => (item ? item.key : '')}
                                        placeholder={defaultPlaceholder}
                                        translateWithId={(id) => listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={selectionFeedback}
                                        onChange={({ selectedItems }) => props.handleChangeAutomata(selectedItems, i)}
                                        // downshiftProps={props.tasksArray[i].automataArray}
                                        initialSelectedItems={props.tasksArray[i].automataArray.length>1 ? props.tasksArray[i].automataArray: []}
                                        onMenuChange={(e) => {
                                            multiSelectProps.onMenuChange(e);
                                        }}
                                        selectedItems={props.tasksArray[i].automataArray}
                                        selectedItem={props.tasksArray[i].automataArray}
                                    />
                                </div>
                            </div>
                            <div className="bx--row action-container">
                                <div className="bx--col bx--col-sm-4">
                                    <Checkbox checked={props.tasksArray[i].fail_fast_on_any_errors} onChange={(e) => props.handleCheckedFailFast(e, i)} labelText={FailFastOnAnyErrors} id={"task1checkbox" + i} />

                                </div>
                                <div className="bx--col bx--col-sm-4">
                                    <Checkbox checked={props.tasksArray[i].isInitialTask} onChange={(e) => props.handleCheckedInitialTask(e, i)} labelText={IsInitialTask} id={"initalTask" + i} />
                                </div>
                                {!props.review ? <div className="bx--col bx--col-sm-4 action-items">
                                    <Button kind="ghost" onClick={props.renderNewTask}>{AddTask}</Button>
                                    {/* <Button kind="tertiary">{SaveTask} {i + 1}</Button> */}
                                </div>
                                    : ''}
                            </div>
                        </div>
                    </div>
                ))}
            </>
        )
    } else {
        return (
            <div>
                <h2>{i18n.t('editScheduleRecommendation.please')}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {i18n.t('editScheduleRecommendation.signup')} </a> </h2>
            </div>
        );
    }

}

export default AddTask